(function () {
  'use strict';

  function initVideoBlock(container) {
    if (container.dataset.videoInitialized) return;
    container.dataset.videoInitialized = 'true';

    const trigger = container.querySelector('[data-video-play-trigger]');
    const cover = container.querySelector('[data-video-cover]');
    const mediaWrapper = container.querySelector('[data-video-media-wrapper]');
    const template = container.querySelector('[data-video-template]');

    if (!mediaWrapper || !template) return;

    function playVideo() {
      const content = template.content.cloneNode(true);
      mediaWrapper.innerHTML = '';
      mediaWrapper.appendChild(content);

      mediaWrapper.classList.remove('tuya-product-video__media-wrapper--hidden');
      if (cover) {
        cover.style.display = 'none';
      }

      const nativeVideo = mediaWrapper.querySelector('video');
      if (nativeVideo) {
        nativeVideo.play().catch(err => console.log(err));
      }
    }

    if (trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        playVideo();
      });
    }

    if (cover) {
      cover.addEventListener('click', function(e) {
        if (e.target.closest('button')) return;
        playVideo();
      });
    }

    const autoplay = container.dataset.autoplay === 'true';
    if (autoplay && !cover) {
      playVideo();
    }
  }

  function initAllVideos() {
    document.querySelectorAll('.tuya-product-video__player-container').forEach(container => {
      initVideoBlock(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVideos);
  } else {
    initAllVideos();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const sectionVideos = event.target.querySelectorAll('.tuya-product-video__player-container');
    sectionVideos.forEach(container => {
      initVideoBlock(container);
    });
  });
})();
